import {
  B2bAdminBillingChannel,
  B2bAdminRoles,
  B2bAdminStatus,
  B2bAdminsLanguagePreference,
} from '@Common/types/bo/b2b/admins';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const adminStatusChoices = makeChoicesCommon<B2bAdminStatus>()({
  active: 'resources.bo_common.b2b.companies.admins.choices.status.active',
  inactive: 'resources.bo_common.b2b.companies.admins.choices.status.inactive',
  pending: 'resources.bo_common.b2b.companies.admins.choices.status.pending',
  invited: 'resources.bo_common.b2b.companies.admins.choices.status.invited',
});

export const adminRoleChoices = makeChoicesCommon<B2bAdminRoles>()({
  admin_level_1: 'resources.bo_common.b2b.companies.admins.choices.role.admin_level_1',
  admin_level_2: 'resources.bo_common.b2b.companies.admins.choices.role.admin_level_2',
  admin_level_3: 'resources.bo_common.b2b.companies.admins.choices.role.admin_level_3',
  admin_level_4: 'resources.bo_common.b2b.companies.admins.choices.role.admin_level_4',
});

export const languagePreferenceChoices = makeChoicesCommon<B2bAdminsLanguagePreference>()({
  FR: 'resources.bo_common.b2b.companies.admins.choices.language_preference.FR',
  EN: 'resources.bo_common.b2b.companies.admins.choices.language_preference.EN',
});

export const billingChannelChoices = makeChoicesCommon<B2bAdminBillingChannel>()({
  paper: 'resources.bo_common.b2b.admins.choices.billing_channel.paper',
  email: 'resources.bo_common.b2b.admins.choices.billing_channel.email',
  both: 'resources.bo_common.b2b.admins.choices.billing_channel.both',
});
